import { Input } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useTrackInvoicingSettings } from '@features/invoicingSettings/hooks/useTrackInvoicingSettings'

import { useFormContext } from '../../../../../../../../../../../../hooks'
import { useDebouncedCallback } from '../../../../../../../../../../../../hooks/useDebouncedCallback'
import { InvoiceSettingsFormSchema } from '../../../../../../types/invoiceSettingsFormSchema'

export const Iban = (): ReactElement => {
  const { t } = useTranslation()
  const { trackInvoicingSettings } = useTrackInvoicingSettings()
  const { FormItem } = useFormContext<InvoiceSettingsFormSchema>()

  const handleDebouncedIbanInputChange = useDebouncedCallback(() => trackInvoicingSettings('IBAN typed'))

  return (
    <FormItem
      name="paymentMethods.iban"
      label={t('settings.organization.external_invoice.payment_methods.bank_transfer.default_iban.label')}
      render={({ field: { onChange, ...rest } }) => (
        <Input
          {...rest}
          onChange={(event) => {
            onChange(event)
            handleDebouncedIbanInputChange()
          }}
        />
      )}
    />
  )
}
